import React, { Component } from "react";
import {Button, Col, Modal, Row} from "antd";
import CardExtraFunctionalities from "./CardExtraFunctionalities";
import CardSecondExtraFunctionalities from "./CardSecondExtraFunctionalities";
import ExtraPaymentInfoModal from "./ExtraPaymentInfoModal";
import { injectIntl } from "react-intl";
import { sendNotification } from "../../../utils";
import CloseIcon from "../../../assets/fi_x-circle.svg";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {updateClientes} from "../../../actions/ClientAction";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ExtraPaymentModal.css";
import {updatePlanServicesByUser, updatePlanLinkGenerate, reducePlan} from "../../../actions/PlanServicesAction";
import _ from "lodash";
import {updateClientPlans, calculateDiff} from '../../../utils/plan-utils';
import { getClientDataById } from '../../../actions/ClientAction'
import { freePlanPrice } from "../../../utils/constants";

class ExtraPaymentModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 1,
      visible: false,
      acum: 0,
      showContract: true,
      keyCompartir: true,
      keyHost: true,
      keyAutenticacion: true,
      keyGrupos: true,
      showExtraInfoPaymentModal: false,
      userPacks: [],
      dataDiff: [],
      userPacksOld: [],
      totalCalc: 0,
      hiddenBtnBuy: true,
      cart:[],
      loadingFetchData: false,
      data: []
    };

    this.infoModalRef = React.createRef();
  }

  componentDidMount() {
    this.updateUserPacks();
  }

  updateUserPacks = () => {
    const ids = (this.props.userServices || []).map(e => e.idService ? e.idService : e.idService);
    const userPacks = [];
    for(const idx in this.props.planServices){
      if(ids.includes(this.props.planServices[idx].idService)){
        const index =  ids.indexOf(this.props.planServices[idx].idService);
        if(index >= 0){
          userPacks.push({
            ...this.props.planServices[idx],
            quantity: this.props.userServices[index].quantity,
            idService: this.props.userServices[index].idService
          })
        }
      }
    }
    const freeServices = (this.props.userServices || []).filter(e => e.is_free === "true");
    const toSave = freeServices.map(e => ({
      ...e,
      _id: e.idService,
      is_free: "true"
    }));
    userPacks.push(...toSave)
    this.setState({
      userPacks: userPacks,
      userPacksOld: userPacks
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      userPacks: oldData
    } = prevState;

    const {
      reducePlanLoading: reducePlanLoadingOld,
      linkGenerateLoading: linkGenerateLoadingOld,
      fetchingUserServices: fetchingUserServicesOld
    } = prevProps;

    const {
      userPacks: newData
    } = this.state;

    const {
      reducePlanLoading: reducePlanLoadingNew,
      reducePlanError,
      workclient,
      intl,
      handleHiddenModalExtraPayment,
      linkGenerateLoading: linkGenerateLoadingNew,
      linkGenerateError,
      linkGenerate,
      userServices,
      showModalExtraPayment,
      fetchingUserServices: fetchingUserServicesNew
    } = this.props;

    const temp = this.state.userPacks; 
    if (showModalExtraPayment !== prevProps.showModalExtraPayment) {
      if(!showModalExtraPayment){
        this.setState({
          step: 1,
        })
        this.updateUserPacks();
      }else if (this.props.initialPlanService){
        temp.push({
          ...this.props.initialPlanService,
          quantity: 1
        });
        this.setState({
          userPacks: temp
        }, () => {
          const newDiff = calculateDiff(userServices, newData);
          this.setState({
            dataDiff: newDiff
          });
        })
      }
    }
    if(linkGenerateLoadingOld && !linkGenerateLoadingNew && !linkGenerateError && linkGenerate){
      if(!showModalExtraPayment) return;
      window.open(linkGenerate, "_self", "noreferrer");
    }
    if(this.props.userServices !== prevProps.userServices){
      this.updateUserPacks();
    }
    if(fetchingUserServicesOld && !fetchingUserServicesNew){
      this.props.getClientDataById(workclient);
    }
    if(newData !== oldData){
      const newDiff = calculateDiff(userServices, newData);
      this.setState({
        dataDiff: newDiff
      });
    }
    if(reducePlanLoadingOld && !reducePlanLoadingNew && !reducePlanError){
      if(!showModalExtraPayment) return;
      const newDataClean = newData.filter(e => e.idService);
      this.props.updatePlanServicesByUser(
        workclient,
        newDataClean.map(x => ({ ...x,qty: x.quantity })),
        intl
      );
      handleHiddenModalExtraPayment();
    }
  }

  handleCancelFirstModal = () => {
    const { handleHiddenModalExtraPayment } = this.props;

    handleHiddenModalExtraPayment();

    this.setState({
      step: 1,
      visible: false,
      cart: [],
    });
    
  };

  handleShowInfoMomdal = () => {
    this.infoModalRef.current.showInfoModal();
  };

  handleHiddenModalInfoExtraPayment = () => {
    this.setState({
      showExtraInfoPaymentModal: false
    });
  };

  addUserPackQty = (id, qty) => {
    const { userPacks } = this.state;
    const ind = userPacks.findIndex(item => item.idService === id);

    if (ind >= 0) {
      userPacks[ind].quantity += qty;
      if (userPacks[ind].quantity < 0) userPacks[ind].quantity = 0;
      this.setState({
        userPacks: userPacks.filter(e => e.quantity > 0)
      });
    }else{
      const newItem = this.props.planServices.find(e =>  e.idService === id);
      if(newItem){
        this.setState({
          userPacks: [...this.state.userPacks, {
            ...newItem,
            quantity: 1
          }]
        });
      }
    }
  };

  addFunctionalService = (id) => {
    const newItem = this.props.planServices.find(e => e.idService === id);
    this.setState({
      userPacks: [...this.state.userPacks, {
        ...newItem,
        quantity: 1
      }]
    });
  }
  removeFunctionalService = (id) => {
    const newItem = this.state.userPacks.filter(e => e.idService !== id);
    this.setState({
      userPacks: newItem
    });
  }
  addToCart = (id, product, qty, show=false) => {
    const {cart, userPack, userPacks} = this.state;
    const ind = cart.findIndex(item => item.idService === id);

    
    if (ind >= 0) {
      cart[ind].qty += qty;
      if (cart[ind].qty < 0) cart[ind].qty = 0;
    } else {
      cart.push({...product, qty})
    }

    if (show){
      let key = userPack.findIndex(item => item.idService === id);
      if(key >= 0){
        userPack[key].buy = false
      }
      
      let packskey = userPacks.findIndex(item => item.idService === id);
      if(packskey >= 0 && userPacks[packskey].qty !== 0){
        userPacks[packskey].buy = false
      }
    }
    
    this.setState({cart});
  };

  calculateTotal = () => {
    const { userPacks } = this.state;
    let sum = freePlanPrice;
    
    for (const item of userPacks) {
      sum += item.quantity * Number(item.price);
    }

    return sum;
  };

  nextStep = () => {
    const {intl} = this.props;
    const {step, cart, userPacksOld} = this.state;

    if (step === 1) {
      if (this.calculateTotal() === 0 && userPacksOld.length < 3) {
        sendNotification('error', intl, intl.formatMessage({id: 'cart_is_empty'}));
        return;
      }

      const sortedByCat = cart.sort((p1, p2) => {
        return (p1.category < p2.category) ? 1 : (p1.category > p2.category) ? -1 : 0
      });

      this.setState({
        cart: sortedByCat,
        step: step + 1
      });
    }
  };

  updateClient = () => {
    const {client, intl, workclient} = this.props;
    const { userPacks: data, dataDiff } = this.state;
    const {usersData, planServices} = this.props;

    const resp = updateClientPlans(client, intl, data, dataDiff, usersData, planServices);
    if(resp.action === "error") return;
    if(resp.action === "reduce_plan") {
      this.props.reducePlan(workclient, resp.data.amount, intl);
      return;
    }
    if(resp.action === "update_plan"){
      this.props.updatePlanLinkGenerate(workclient, resp.data.amount, intl, resp.data.modules)
      return;
    }
  };

  handleCancel = () => {
    
    this.setState({
      step: 1,
      visible: false,
      cart: [],
    });
  };

  functionalServices = () => this.props.planServices.filter(e => e.type === "3");
  
  otherServices = () => this.props.planServices.filter(e => e.type !== "3");
  
  render() {
    const {
      showModalExtraPayment,
      handleHiddenModalExtraPayment,
      intl,
      newColor,
      reducePlanLoading,
      linkGenerateLoading
    } = this.props;

    const settingsSlider = {
    };

    const {
      step,
      dataDiff
    } = this.state;

    return (
      <Modal
        visible={showModalExtraPayment}
        onCancel={handleHiddenModalExtraPayment}
        footer={null}
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="modal-parent modal-pay"
        scrollableBody={true}
        style={{ top: 20 }}
        destroyOnClose
      >   
      <div hidden={step !== 1} id="step3" className="step" style={{paddingTop: "50px"}}>
      <div className={'scroll-step'} style={{overflow: 'auto', overflowX: 'hidden', height: '70vh', scrollbarTrackColor: 'white', marginBottom: '5px'}}>
        <Row 
              type={"flex"}
              gutter={[10, 10]}
              justify={"space-between"}
            >
              <Col span={18}>
                <span style={{ fontSize: 30, fontWeight: 700, color: newColor }}>
                  {intl.formatMessage({ id: "extra_payment.title" })}
                </span>
              </Col>
              <Col span={6}></Col>
              <Col span={18}></Col>
              <Col span={6}></Col>
              <Col xs={24} sm={24} lg={12} span={12}>
                <div>
                  <Slider className="order-card-extra"  {...settingsSlider}>
                    <Row>
                      {
                        this.functionalServices().map(item => { 
                          const result = this.state.userPacks.find(({ _id }) => _id === item.idService);
                          const hired = !_.isNil(result);
                          return (
                            <div
                              key={item.idService}
                            >
                              <Col lg={12}>
                              <CardExtraFunctionalities
                                showInfoModal={this.handleShowInfoMomdal}
                                title={item.product}
                                hired={hired}
                                enable
                                price={item.price}
                                id={ item.idService }
                                qty={ 1 }
                                product={ item }
                                addToCart={ this.addFunctionalService }
                                removeToCart={ this.removeFunctionalService }
                              />
                            </Col>
                            </div>
                          )
                        })
                      }
                    </Row>
                  </Slider>
                </div>
              </Col>
              <Col className="div-bottom-detected" xs={24} sm={24} lg={11} span={11} style={{ marginBottom: 100, marginTop: 50 }}>
                <Row gutter={[20, 20]}>
                  {this.otherServices().map(item => {
                    const result = this.state.userPacks.find(({ _id }) => _id === item.idService) || item;
                    return (
                      <Col span={24} key={item.idService}>
                        <CardSecondExtraFunctionalities
                          title={item.product}
                          price={item.price}
                          hidden={false}
                          id={item.idService}
                          qty={result.quantity || 0}
                          product={item}
                          addUserPackQty={this.addUserPackQty}
                          addToCart={this.addToCart}
                        />
                      </Col>
                    )})}
                </Row>
              </Col>
              <Col className="div-hidden-detected" span={24} style={{ marginBottom: 70 }}></Col>
        </Row>
      </div>
        <div>
          <Row gutter={25} type="flex" justify="space-around" align="middle" style={{paddingTop: '20px',boxShadow: 'rgb(0 0 0 / 50%) 0px -6px 6px -6px'}}>
            <Col md={9} xs={18} span={15}>
              <div className="container">
                <h4><b>{intl.formatMessage({id: "extra_payment.monthly"})}</b></h4>
                <p>{intl.formatMessage({id: "extra_payment.next_bill"})}</p>
              </div>
            </Col>
            <Col md={6} xs={6} span={15}>
              <b style={{color: newColor, fontSize: "24px"}}>
                <span>${this.calculateTotal()} USD</span>
              </b>
            </Col>
            <Col md={9} xs={24} span={9}>
              <div style={{
                textAlign: "right",
                paddingRight: "20px"
              }}>
              <Button
                type="default"
                style={{marginRight: "10px"}}
                onClick={this.handleCancelFirstModal}
              >
                {intl.formatMessage({ id: "cancel_button" })}
              </Button>

              <Button
                type="primary"
                onClick={this.nextStep}
              >
                {intl.formatMessage({ id: "checkout" })}
              </Button>
              </div>
            </Col>
          </Row>
      </div>
      </div>
          <ExtraPaymentInfoModal
            handleHiddenModalInfoExtraPayment={
              this.handleHiddenModalInfoExtraPayment
            }
            compRef={this.infoModalRef}
          />
        
        {/** END STEP 1 */}

        <div hidden={step !== 2} id="step2" className="step">
        <Row gutter={25}>
              <Col md={14} xs={24} span={24}>
                <h4 className="title-dashboard">
                  <b className="color-title-dashboard">{intl.formatMessage({id: 'payment_detail'})}</b>
                </h4>
              </Col>
            </Row>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead style={{backgroundColor: newColor, color: "white"}}>
                <tr>
                  <th>{intl.formatMessage({id: 'item'})}</th>
                  <th>{intl.formatMessage({id: 'product'})}</th>
                  <th>{intl.formatMessage({id: 'quantity'})}</th>
                  <th>{intl.formatMessage({id: 'price'})}</th>
                </tr>
                </thead>
                <tbody>
                {dataDiff.map((item, i) => {
                  return (
                    <tr key={i}>
                      <td>
                        {item.item}
                      </td>
                      <td>
                        {item.category === "features" ? item.title : item.product}
                      </td>
                      <td>
                      {item.type !== '3' && <div style={{ display: 'flex', justifyContent: 'space-between', width: 100, margin: '0 auto' }}>
                          {item.is_free !== "true" && <Button
                            type={'primary'}
                            style={{ margin: '0 auto', display: 'block', width: 27, }}
                            size={'small'}
                            onClick={() => this.addUserPackQty(item.idService, -1)}
                          >
                            <span><img src="/images/img_v2/icon-btn-minus.svg" alt='filtro'/></span>
                          </Button>}
                          <Button
                            style={{ margin: '0 auto', display: 'block', }}
                            size={'small'}
                          >
                            {item.quantity}
                          </Button>
                          {item.category !== "features" && item.is_free !== "true" && (
                            <Button
                              type={'primary'}
                              style={{ margin: '0 auto', display: 'block', width: 27, padding: '0 4px' }}
                              size={'small'}
                              onClick={() => this.addUserPackQty(item.idService, 1)}
                            >
                              <span><img src="/images/img_v2/icon-btn-add.png" alt='filtro'/></span>
                            </Button>
                          )}
                        </div>}
                      </td>
                      <td>
                        {item.quantity * item.price} USD
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan={2} className="text-right"></td>
                  <td colSpan={1} className="left"><b>TOTAL</b></td>
                  <td colSpan={1} className="left"><b>{this.calculateTotal()} USD</b></td>

                </tr>
                </tbody>
              </table>
            </div>
            <div className="text-right">
              <Button type="default"
                onClick={this.handleCancel}
                disabled={false}
                style={{marginRight: "10px", fontWeight: "700",}}
              >
                {intl.formatMessage({id: 'cancel_button'})}
              </Button>
              <Button type="primary"
                disabled={false}
                onClick={this.updateClient}
                style= {{ fontWeight: "700", }}
                loading = {reducePlanLoading || linkGenerateLoading}
              >
                  {intl.formatMessage({id: 'go_pay'})}
              </Button>
            </div>
        </div>  
          
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    contractedUsers: state.client && state.client.data ? state.client.data.contractedUsers : null,
    data: state.users.data,
    workclient: state.client.workclient,
    userExists: state.users.userExists,
    invitationSent: state.users.invitationSent,
    client: state.client.data,
    clientUpdate: state.client.clientUpdate,
    planServices: state.planServices.data,
    userServices: state.planServices.userServices,
    usersData: state.users.data,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    reducePlanLoading: state.planServices.reducePlanLoading,
    reducePlanError: state.planServices.reducePlanError,
    linkGenerateLoading: state.planServices.linkGenerateLoading,
    linkGenerateError: state.planServices.linkGenerateError,
    linkGenerate: state.planServices.linkGenerate,
    fetchingUserServices: state.planServices.fetchingUserServices
  };
};

const mapDispatchToProps = {
  updateClientes,
  updatePlanServicesByUser,
  updatePlanLinkGenerate,
  reducePlan,
  getClientDataById
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ExtraPaymentModal))
);

